import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const forgetSlice = createSlice({
  name: "forget",
  initialState,
  reducers: {},
});

export const {} = forgetSlice.actions;
export default forgetSlice.reducer;
